import gql from 'graphql-tag'
import { expeditionDetailFields } from './expeditionGetQuery'

// update of an expedition in fulfillment, keep in sync with `carrierEditProperties`
const expeditionCarrierUpdateQuery = gql`
  query expeditionCarrierUpdate(
    $id: String!
    $note: String
    $billingFirstName: String!
    $billingLastName: String!
    $billingDegree: String
    $billingCompany: String
    $billingStreet: String!
    $billingHouseNr: String!
    $billingZip: String!
    $billingCity: String!
    $billingCountry: String!
    $billingState: String!
    $billingEmail: String!
    $billingPhone: String!
    $billingRegistrationNumber: String
    $billingVatNumber: String
    $differentDeliveryAddress: Boolean
    $deliveryFirstName: String
    $deliveryLastName: String
    $deliveryDegree: String
    $deliveryCompany: String
    $deliveryStreet: String
    $deliveryState: String
    $deliveryHouseNr: String
    $deliveryZip: String
    $deliveryCity: String
    $deliveryCountry: String
    $deliveryEmail: String
    $deliveryPhone: String
    $carrier: String!
    $carrierService: String!
    $carrierPickupPlace: String
    $externalCarrierPickupPlace: String
    $carrierNote: String
    $carrierOptions: String
  ) {
    expeditionUpdate(
      id: $id
      input: {
        note: $note
        billingFirstName: $billingFirstName
        billingLastName: $billingLastName
        billingDegree: $billingDegree
        billingCompany: $billingCompany
        billingStreet: $billingStreet
        billingHouseNr: $billingHouseNr
        billingZip: $billingZip
        billingCity: $billingCity
        billingState: $billingState
        billingCountry: $billingCountry
        billingEmail: $billingEmail
        billingPhone: $billingPhone
        billingRegistrationNumber: $billingRegistrationNumber
        billingVatNumber: $billingVatNumber
        differentDeliveryAddress: $differentDeliveryAddress
        deliveryFirstName: $deliveryFirstName
        deliveryLastName: $deliveryLastName
        deliveryDegree: $deliveryDegree
        deliveryCompany: $deliveryCompany
        deliveryStreet: $deliveryStreet
        deliveryState: $deliveryState
        deliveryHouseNr: $deliveryHouseNr
        deliveryZip: $deliveryZip
        deliveryCity: $deliveryCity
        deliveryCountry: $deliveryCountry
        deliveryEmail: $deliveryEmail
        deliveryPhone: $deliveryPhone
        carrier: $carrier
        carrierService: $carrierService
        carrierPickupPlace: $carrierPickupPlace
        externalCarrierPickupPlace: $externalCarrierPickupPlace
        carrierNote: $carrierNote
        carrierOptions: $carrierOptions
      }
    ) @rest(type: "Expedition", method: "PUT", path: "expedition/{args.id}") {
      ${expeditionDetailFields}
    }
  }
`

export default expeditionCarrierUpdateQuery
